import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/admin/guard';
import { JobRoleList } from '@/features/resources/job-roles/job-role-list';
import { requireResourcesFeature } from '@/features/resources/guard';

export const Route = createFileRoute('/_app/admin/job-roles')({
  beforeLoad: async ({ context }) => {
    requirePermission(context.me, 'job_roles.manage');
    await requireResourcesFeature(context.queryClient);
  },
  component: JobRoleList,
});
